/* Projects.tsx
    Une page affichant la gestion des affaires
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les éléments
    Utilise l'API correspondante pour les opérations de données
*/

import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { ProjectsCrudCard } from 'features/projects/components/ProjectsCrudCard';
import PageHeader from 'layout/PageHeader';

export const Projects = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faBriefcase}
			title="Affaires"
			subtitle="Gérez les affaires avec vos clients et vos fournisseurs"
		/>
		<ProjectsCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
